// extracted by mini-css-extract-plugin
var _1 = {"name":"SITE-Help-Menu-Item-Incidents"};
var _2 = {"icon":"SITE-Help-Menu-Item-Incidents__icon","description":"SITE-Help-Menu-Item-Incidents__description","link":"SITE-Help-Menu-Item-Incidents__link"};
var _3 = {};
export { _1 as "b", _2 as "e", _3 as "m" }
